import React from "react";
import { Button } from "antd";
import { useCreateDomainVisibilityAnalysisProcessMutation } from "../service";
import { ModelFamily } from "../types";

type Props = {
    domain: string;
    modelFamily: ModelFamily;
    inProgress: boolean;
    setIsRefreshingAnalysis: (isLoading: boolean) => void;
    onAnalysisStarted: (processGuid: string) => void;
};


export default function RefreshAnalysisButton({ inProgress, domain, modelFamily, setIsRefreshingAnalysis, onAnalysisStarted }: Props) {
    const [isLoading, setIsLoading] = React.useState(inProgress);
    const [startDomainContentAnalysis] = useCreateDomainVisibilityAnalysisProcessMutation();

    const handleRefreshAnalysis = async () => {
        setIsLoading(true);
        setIsRefreshingAnalysis(true);
        const process = await startDomainContentAnalysis({ domain, modelFamily }).unwrap();
        // The page watches the process it just started. Nothing else knows its guid, and without
        // it the page would keep reading the previous process instead of this one.
        onAnalysisStarted(process.guid);
        setIsRefreshingAnalysis(false);
    }

    React.useEffect(() => {
        setIsLoading(inProgress);
    }, [inProgress]);

    return (
        <Button
            className="refresh-analysis-button"
            size="small"
            loading={isLoading}
            onClick={handleRefreshAnalysis}
            icon={"sync"}
        >
            Refresh analysis
        </Button>
    );
}
